import LogoWideWhite from '@/assets/images/icons/LogoWideWhite.svg'
import { EcommerceSelector } from '@/ui/shared/layout'

export const NavbarHeader = () => {
  return (
    <>
      <header className="flex items-center px-1.5 pt-2">
        <img width={148} height={32} src={LogoWideWhite} alt="REVER" />
      </header>
      <EcommerceSelector />
    </>
  )
}
